module.exports = __webpack_public_path__ + "Onboardingdesign2.svg?8885855dc18334d36094701f1121d741";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Onboardingdesign2.svg
// module id = 81
// module chunks = 0